import script from "./AiChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChatbot.vue?vue&type=script&setup=true&lang=js"

import "./AiChatbot.vue?vue&type=style&index=0&id=2da41a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da41a1e"]])

export default __exports__